import React from "react";

import Button from "@common/components/Button/Button";
import Option from "@common/components/Option/Option";
import { vars } from "@common/styles";
import { UserFeedbackAddNewTicketView } from "@main/pages/UserFeedback/views/UserFeedbackAddNewTicketView/UserFeedbackAddNewTicketView";
import UserFeedbackDiscardNewTicketModal from "@main/pages/UserFeedback/views/UserFeedbackAddNewTicketView/UserFeedbackDiscardNewTicketModal";
import { useUserFeedbackAddNewTicketModal } from "@main/pages/UserFeedback/views/UserFeedbackAddNewTicketView/useUserFeedbackAddNewTicketModal";
import { useUserFeedbackAddNewTicketView } from "@main/pages/UserFeedback/views/UserFeedbackAddNewTicketView/useUserFeedbackAddNewTicketView";

type UserFeedbackAddTicketModalProps = ReturnType<typeof useUserFeedbackAddNewTicketModal>;

export const UserFeedbackAddNewTicketModal = ({
  AddNewTicketModal,
  addNewTicketModalProps,
  isCreateAnotherTicket,
  setCreateAnotherTicket,
  onTicketCreated,
  onInfoClick,
  discardNewTicketModal,
  onDirtyChanged,
}: UserFeedbackAddTicketModalProps) => {
  const addNewTicketViewProps = useUserFeedbackAddNewTicketView({
    onTicketCreated,
    onDirtyChanged,
  });

  return (
    <AddNewTicketModal
      {...addNewTicketModalProps}
      heading={"Create a new ticket"}
      buttonElement={
        <Button
          size="small"
          disabled={addNewTicketViewProps.loading}
          loadingText={addNewTicketViewProps.loading ? "Creating..." : false}
          onClick={() => addNewTicketViewProps.createNewTicket()}
        >
          {"Create"}
        </Button>
      }
      additionalElement={
        <Option
          style={{ marginRight: "6rem", color: vars.colors.grey30 }}
          label="Create another"
          checked={isCreateAnotherTicket}
          handleCheck={(e) => setCreateAnotherTicket(e.target.checked)}
        />
      }
      info={"Click to learn more about creating tickets manually"}
      onInfoClick={onInfoClick}
      hasSeparator={false}
      disableScroll={true}
    >
      <UserFeedbackAddNewTicketView {...addNewTicketViewProps} />

      {discardNewTicketModal.active ? <UserFeedbackDiscardNewTicketModal {...discardNewTicketModal} /> : null}
    </AddNewTicketModal>
  );
};
